import Enum from './enum'

class NotificationType extends Enum
{
  constructor(value) {
    super(value);
  }
}

NotificationType.init({
  ACCREDITATION_REQUEST: 'Accreditation',
  ACCREDITATION_APPROVED: 'AccreditationApprove',
  ACCREDITATION_DECLINED: 'AccreditationDecline',
  ACCREDITATION_EXPIRED: 'AccreditationExpire',
  TENDER_INVITED_PUBLISHED: 'TenderInvite',
  TENDER_MODIFIED: 'TenderModified',
  TENDER_PUBLISHED: 'TenderApprove',
  TENDER_FINISHED: 'ProtocolAccept',
  LOT_COMMENTED_BY_ORG: 'LotCommentOrganizer',
  LOT_COMMENTED_BY_PARTICIPANT: 'LotCommentParticipant',
  LOT_COMMENT_UPDATED_BY_ORG: 'LotCommentUpdateOrganizer',
  LOT_COMMENT_UPDATED_BY_PARTICIPANT: 'LotCommentUpdateParticipant',
  PROTOCOL_ATTACHED: 'Protocol',
  DRAFT_PROTOCOL_ATTACHED: 'DraftProtocol',
  REQUEST_CLARIFICATION_REQUESTED: 'Clarification',
  REQUEST_CLARIFICATION_RECEIVED: 'ClarificationAnswer',
  BID_CLARIFICATION_REQUESTED: 'ClarificationBid',
  BID_CLARIFICATION_RECEIVED: 'ClarificationBidAnswer',
  RETEND_PUBLISHED: 'Retend',
  SIGNATURE_REQUEST: 'Ep',
  QUESTION_RECEIVED: 'MessageQuestion',
  COMPLAINT_RECEIVED: 'MessageComplaint',
  LOT_CANCELLED: 'LotCancel',
  TENDER_COMMITTED_FOR_APPROVE: 'TenderSendCommit',
  RETEND_PROTOCOL_SIGNED: 'ProtocolRetend',
  LOT_CANCELLED_REQUEST: 'LotSendToCancel',
  LOT_APPROVAL_REQUEST: 'LotSendToCommit',
  LOT_APPROVED: 'LotApprove',
  LOT_DECLINED: 'LotDecline',
  BID_SUSPENDED: 'RequestBidSuspend',
  LOT_BID_ADJUST_ALLOWED: 'RequestAdjustBid',
  LOT_CRITERION_ADJUST_ALLOWED: 'RequestAdjustCriterion',
  LOT_DOCUMENT_ADJUST_ALLOWED: 'RequestAdjustDocument',
  RETEND_STARTED: 'RetendStart',
  RETEND_SENT_FOR_APPROVAL: 'RetendSendAccept',
  BID_DECLINED: 'RequestBidDecline',
  BID_ACCEPTED: 'BidAccept'
});

export default NotificationType;
